/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Num = alm.util.Num;

	export class FloatingStats extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view:JQuery = this.getView();

			this.elevation = view.find('.elevation .text');
			this.distance = view.find('.distance .text');

			this.line = jQuery('.floating-stats-line');
			this.lineImage = this.line.find('.image');

			this.screenPosition = new THREE.Vector3();
			this.threeManager = ThreeManager.getInstance();

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
				this.line.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
				this.line.css('display', 'none');
			});
		}





		public setCurrentMarkerPosition(markerPosition:THREE.Vector3):void {
			this.threeManager.project(markerPosition, this.screenPosition);

			const visibility = this.screenPosition.z > 1;

			const dataX = this.screenPosition.x + 60;
			const dataY = this.screenPosition.y + 20;

			const lineStartX = this.screenPosition.x + 20;
			const lineStartY = this.screenPosition.y + 10;

			const lineEndX = dataX - 10;
			const lineEndY = dataY + 10;

			const lineDx = lineEndX - lineStartX;
			const lineDy = lineEndY - lineStartY;

			const lineAngle = Math.atan2(lineDy, lineDx);
			const lineDistance = Math.sqrt(lineDx * lineDx + lineDy * lineDy);

			this.getView().css({
				left: dataX,
				top: dataY,
				display: visibility ? 'none' : 'block',
			});

			this.line.css({
				left: lineStartX,
				top: lineStartY,
				display: visibility ? 'none' : 'block',
			});

			this.lineImage.css({
				width: lineDistance,
				transform: 'translateY(-50%) rotate(' + Num.radToDeg(lineAngle) + 'deg)',
			});
		}





		public setCurrentElevation(elevation:number):void {
			this.elevation.text(Math.floor(elevation).toLocaleString() + ' m');
		}

		public setCurrentDistance(distance:number):void {
			distance = Math.floor(distance / 100) / 10;
			this.distance.text(distance.toFixed(1) + ' km');
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private elevation:JQuery;
		private distance:JQuery;

		private line:JQuery;
		private lineImage:JQuery;

		private threeManager:ThreeManager;
		private screenPosition:THREE.Vector3;
	}
}
